import { shallowRef, createSSRApp, createApp, shallowReactive, nextTick, h } from "vue";
import { setPageContext } from "./hooks/usePageContext.js";
import { setData } from "./hooks/useData.js";
function objectAssign(obj, objAddendum) {
  Object.assign(obj, objAddendum);
}
function callCumulativeHooks(hooks, pageContext) {
  return Promise.all((hooks == null ? void 0 : hooks.map((hook) => typeof hook === "function" ? hook(pageContext) : hook)) ?? []);
}
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  return (
    /* Doesn't work in Cloudflare Pages workers
    value.constructor === Object
    */
    value.constructor.name === "Object"
  );
}
async function createVueApp(pageContext, ssr, mainComponentName) {
  const mainComponentRef = shallowRef(pageContext.config[mainComponentName]);
  const layoutRef = shallowRef(pageContext.config.Layout || []);
  const MainComponent = () => h(mainComponentRef.value);
  let RootComponent = MainComponent;
  if (mainComponentName === "Page") {
    RootComponent = () => {
      let RootComp = MainComponent;
      layoutRef.value.forEach((layout) => {
        const Comp = RootComp;
        RootComp = () => h(layout, null, Comp);
      });
      return RootComp();
    };
  }
  const app = ssr ? createSSRApp(RootComponent) : createApp(RootComponent);
  objectAssign(pageContext, { app });
  const changePage = async (pageContext2) => {
    let returned = false;
    let err;
    app.config.errorHandler = (err_) => {
      if (returned) {
        console.error(err_);
      } else {
        err = err_;
      }
    };
    const data2 = pageContext2.data ?? {};
    assertDataIsObject(data2);
    objectReplace(dataReactive, data2);
    objectReplace(pageContextReactive, pageContext2);
    mainComponentRef.value = pageContext2.config[mainComponentName];
    layoutRef.value = pageContext2.config.Layout || [];
    await nextTick();
    returned = true;
    if (err)
      throw err;
  };
  const data = pageContext.data ?? {};
  assertDataIsObject(data);
  const dataReactive = shallowReactive(data);
  const pageContextReactive = shallowReactive(pageContext);
  setPageContext(app, pageContextReactive);
  setData(app, dataReactive);
  const { onCreateApp } = pageContext.config;
  const pageContextWithApp = pageContext;
  await callCumulativeHooks(onCreateApp, pageContext);
  if (pageContextWithApp.config.vuePlugins) {
    console.warn("[vike-vue][warning] +vuePlugins.js is deprecated, use onCreateApp() instead");
    pageContextWithApp.config.vuePlugins.forEach(({ plugin, options }) => {
      app.use(plugin, options);
    });
  }
  return { app, changePage };
}
function assertDataIsObject(data) {
  if (!isPlainObject(data))
    throw new Error("Return value of data() should be a plain object, undefined, or null");
}
function objectReplace(obj, objAddendum) {
  Object.keys(obj).forEach((key) => delete obj[key]);
  Object.assign(obj, objAddendum);
}
function isCallable(thing) {
  return thing instanceof Function || typeof thing === "function";
}
function getHeadSetting(headSetting, pageContext) {
  var _a;
  const config = (_a = pageContext.configEntries[headSetting]) == null ? void 0 : _a[0];
  if (!config)
    return void 0;
  const val = config.configValue;
  if (typeof val === "string")
    return val;
  if (!val)
    return null;
  if (isCallable(val)) {
    const valStr = val(pageContext);
    if (typeof valStr !== "string") {
      throw new Error(config.configDefinedAt + " should return a string");
    }
    return valStr;
  } else {
    throw new Error(config.configDefinedAt + " should be a string or a function returning a string");
  }
}
export {
  callCumulativeHooks as a,
  createVueApp as c,
  getHeadSetting as g,
  objectAssign as o
};
//# sourceMappingURL=getHeadSetting-Bd9Y_bSc.js.map
